module.exports = __webpack_public_path__ + "img/sd.16a2cbb1.svg";